import sweetalert from "sweetalert";

export const token = localStorage.getItem("urexperttoken");
export const IS_LOGGED_IN_USER = token ? true : false;
export const IS_TEST_MODE = process.env.PUBLIC_URL == '/urxpert_website_internal_test' || window.location.host === "localhost:3000" ? true : false;
export const IS_TEST_V3 = process.env.PUBLIC_URL == '/urxpert_website_final' ? true : false;
export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const isThisMobileScreen = window.innerWidth <= 768;

export function showFileSizeError() {
    sweetalert({
        title: "File too large",
        text: `Some files exceed the 10MB size limit and were not uploaded.`,
        icon: "error",
        button: "Close",
        timer: 3000,
    });
}

export const getJobProjectProposalsStatusLabel = (status) => {
    const statusMap = {
        2: "You declined",
        3: "Offer Sent",
        4: "Offer Declined",
        5: "Offer Accepted by User",
        21: "Send Offer",
        22: "You declined",
        23: "Offer Sent",
        24: "Offer Declined",
        25: "Offer Accepted",
    };
    return statusMap[status] || "Send Offer";
};

export const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
};

export const addOneDayToDate = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() + 1);
    return formatDate(date);
};

export const getPostType = (type) => {
    const normalizedType = String(type);

    switch (normalizedType) {
        case "1":
            return <span className="project">Project</span>;
        case "2":
            return <span className="contest">Contest</span>;
        case "3":
            return <span className="job">Job</span>;
        case "4":
            return <span className="job">Umbrella Post</span>;
        default:
            return <span className="job">Post...?</span>;
    }
};



export const getSortNamePostType = (type, is_bxp = 0) => {
    switch (type) {
        case "1":
            return <span className="project">{is_bxp ? "OTS" : "PBP"}</span>;
        case "2":
            return <span className="contest">WBO</span>;
        case "3":
            return <span className="job">PTJ</span>;
        default:
            return <span className="job">No Idea</span>;
    }
};


// ✅ Full Post Type Name with Labels
export const getDisputePostType = (type) => {
    switch (type) {
        case "5":
            return <span className="project">Project & Browse Projects</span>;
        case "7":
            return <span className="contest">Win Business Opportunities</span>;
        case "9":
            return <span className="job">Part Time Job</span>;
        case "4":
            return <span className="service">One Time Services</span>;
        case "2":
            return <span className="auction">Buy & Sell with Auction</span>;
        case "8":
            return <span className="rental">Turn Assets to Income</span>;
        case "3":
            return <span className="sale">Buy & Sell with Market</span>;
        case "1":
            return <span className="hiring">Full Time Job</span>;
        case "10":
            return <span className="mergers">Merger & Acquisition Services</span>;
        default:
            return <span className="unknown">Post...?</span>;
    }
};


// ✅ Short Post Type Names (Abbreviations)
export const getDisputeSortNamePostType = (type) => {
    switch (type) {
        case "5":
            return <span className="project">PBP</span>;   // Project & Browse Projects
        case "7":
            return <span className="contest">WBO</span>;  // Win Business Opportunities
        case "9":
            return <span className="job">PTJ</span>;      // Part Time Job
        case "4":
            return <span className="service">OTS</span>;  // One Time Services
        case "2":
            return <span className="auction">BSA</span>;  // Buy & Sell with Auction
        case "8":
            return <span className="rental">TAI</span>;   // Turn Assets to Income
        case "3":
            return <span className="sale">BSM</span>;     // Buy & Sell with Market
        case "1":
            return <span className="hiring">FTJ</span>;   // Full Time Job
        case "10":
            return <span className="mergers">MAS</span>;  // Merger & Acquisition Services
        default:
            return <span className="unknown">No Idea</span>;
    }
};

export const workingdaysOptions = [
    { id: 0, day: 'Sunday' },
    { id: 1, day: 'Monday' },
    { id: 2, day: 'Tuesday' },
    { id: 3, day: 'Wednesday' },
    { id: 4, day: 'Thursday' },
    { id: 5, day: 'Friday' },
    { id: 6, day: 'Saturday' },
];

export const getPostStingName = (type) => {
    switch (type) {
        case "1":
            return "PBP"; // Project & Browse Projects
        case "2":
            return "WBO"; // Win Business Opportunities
        case "3":
            return "PTJ"; // Part Time Job
        case "4":
            return "OTS"; // One Time Services
        case "5":
            return "BSM"; // Buy & Sell with Auction
        case "6":
            return "TAI"; // Turn Assets to Income
        case "7":
            return "BSA"; // Buy & Sell with Market
        case "8":
            return "MAS"; // Merger & Acquisition Services
        case "9":
            return "FTJ"; // Merger & Acquisition Services
        case "10":
            return "Find Experts"; // Merger & Acquisition Services
        default:
            return "No Idea";
    }
};
